import Swiper from "swiper";
import {Pagination, Mousewheel} from 'swiper/modules';
import {mediaBreakpointDown} from "../../../utilities/MediaBreakpoints";

class CarouselScroll extends EventTarget {
    options = {
        modules: [Pagination, Mousewheel],
        direction: "horizontal",
        speed: 800,
        slidesPerView: 'auto',
        enabled: true,
        freeMode: {
            enabled: false,
            sticky: true,
        },
        mousewheel: {
            releaseOnEdges: false,
            sensitivity: .3,
            thresholdTime: 100
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            640: {
                // direction: "vertical",
                // enabled: false,
            }
        }
    }

    constructor({container, root}) {
        super();
        this.container = container;
        this.root = root;
        this.swiper = new Swiper(this.container, this.options);
        this.swiper.on('slideNextTransitionStart', () => this.emitNext());
        this.swiper.on("slidePrevTransitionStart", () => this.emitPrev());
        this.main();
        this.scrolled = (e) => {
            e.preventDefault();
            e.stopPropagation();
            scrollTo({
                top: this.lockedPosition,
                left: 0,
                behavior: "instant",
            });
            return false;
        }
        this.handleScroll = this.scrolled.bind(this);
    }

    main() {
        if (mediaBreakpointDown('lg')) return;
        this.startObserver();
    }

    startObserver() {
        this.observe(this.root, () => {
            this.lockScroll();
            setTimeout(() => {
                this.swiper.enable();
            }, 200);
            this.onCarouselEnded(() => {
                this.unLockScroll();
                this.swiper.disable();
            })
        });
    }

    onCarouselEnded(callback) {
        this.swiper.on('transitionEnd', () => {
            if (this.swiper.isEnd || this.swiper.isBeginning) {
                callback();
            }
        });
    }

    observe(target, callback) {
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: [0.90],
        }
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    callback(entry);
                }
            })
        }, options);
        observer.observe(target)
    }

    lockScroll() {
        addEventListener("scroll", this.handleScroll, false);
    }

    unLockScroll() {
        removeEventListener("scroll", this.handleScroll, false);
    }

    get lockedPosition() {
        return this.root.offsetTop - document.querySelector('header#appHeader').getBoundingClientRect().height;
    }

    emitNext() {
        this.dispatchEvent(new CustomEvent("carousel.scroll.next", {
            detail: {
                carouselId: this.root.dataset.component,
                root: this.root,
                swiper: this.swiper
            }
        }));
    }

    emitPrev() {
        this.dispatchEvent(new CustomEvent("carousel.scroll.prev", {
            detail: {
                carouselId: this.root.dataset.component,
                root: this.root,
                swiper: this.swiper
            }
        }));
    }

}

export default function setupCarouselScroll() {
    let radiant = 0;
    let step = 20;


    function extractValuesFromActiveSlide(slides) {
        const found = slides.find(e => e.classList.contains('swiper-slide-active'));
        if (found !== undefined) {
            return {
                value: found.firstElementChild.dataset.value,
                label: found.firstElementChild.dataset.label
            };
        }
    }

    function setValues({label, value}, root) {
        root.querySelector('.box-app-properties__info__value').textContent = value;
        root.querySelector('.box-app-properties__info__label').textContent = label;
    }

    function handleSlidePrevEvent({detail}) {
        if (detail.carouselId === 'carouselProperties') {
            setValues(extractValuesFromActiveSlide(detail.swiper.slides), detail.root);
            const boxOctagon = detail.root.querySelector('[data-component="octagon"]');
            radiant -= step;
            boxOctagon.style.transform = `rotate(${radiant}deg)`;
        }
    }

    function handleSlideNextEvent({detail}) {
        if (detail.carouselId === 'carouselProperties') {
            setValues(extractValuesFromActiveSlide(detail.swiper.slides), detail.root);
            const boxOctagon = detail.root.querySelector('[data-component="octagon"]');
            radiant += step;
            boxOctagon.style.transform = `rotate(${radiant}deg)`;
        }
    }

    for (const carouselSection of document.querySelectorAll('[data-carousel="carousel-scroll"]')) {
        const carouselScroll = new CarouselScroll({
            root: carouselSection,
            container: document.getElementById(carouselSection.dataset.component)
        });
        carouselScroll.addEventListener('carousel.scroll.next', handleSlideNextEvent, false);
        carouselScroll.addEventListener('carousel.scroll.prev', handleSlidePrevEvent, false);

    }
}
